import React from "react";
import DefaultLayout from "../../layout/DefaultLayout";
import BreadcrumbTwo from "../../components/Breadcrumbs/BreadcrumbTwo";
import SectionWrapper from "../../components/SectionWrapper/SectionWrapper";

const DiscountRulesPage: React.FC = () => {
  return (
    <DefaultLayout>
      <BreadcrumbTwo />
      <SectionWrapper>
        <div className="p-6">
          <h2 className="text-xl font-semibold mb-4">Reglas de Descuento</h2>
          <p>Define porcentajes, montos y operaciones matemáticas.</p>
        </div>
      </SectionWrapper>
    </DefaultLayout>
  );
};

export default DiscountRulesPage;
